var exports = {
  "T": "regexInputContainer__9TBLK8",
  "e": "testRegexButton__Ddgkjs",
};

module.exports = exports;
